import { TmpPackage } from '@/weappTmps/config.js'
import staticDataConfig from '@/view/weappTmp/index.config'

// 组件配置类型
export const CMP_TYPES = ['formTmpsConfig', 'managerTmpsProps']

// 对应组件Props配置项
export const tmpConfigMap = {
  formTmpsConfig: TmpPackage.formTmpsConfig
}
// formTmps.SpInput/config
export function findTarget (source, type, key) {
  // console.log('source[type]',source[type])
  return source[type][`${key}/config`]
}

// 获取目标组件的 propsConfig
export function getTargetProps (type, key) {
  if (CMP_TYPES.indexOf(type) == -1) {
    console.error('CMP_TYPES not find type 请检查该组件类型是否正确')
    return false
  }
  const target = findTarget(tmpConfigMap, type, key)
  console.log('target', target)
  if (!target) {
    console.error(`getTarget not find ${type}-${key} ; 请检查是否正确注册该组件`)
    return false
  }
  return target.props
}

// 合并配置项用于tmpList生成
export function mergeConfig (staticData, packageData) {
  // console.log('mergeConfig-packageData', packageData)
  // console.log('staticData',staticData)
  let initDataMap = {}
  for (let i of staticData) {
    initDataMap[i.name] = i
  }
  for (let j in packageData) {
    initDataMap[packageData[j].name] = packageData[j]
  }
  return Object.values(initDataMap)
}

function getConfig (TmpPackage) {
  const configMap = {}
  for (let i in TmpPackage) {
    if (TmpPackage[i].config) {
      configMap[i] = TmpPackage[i].config
    }
  }
  console.log('configMap', configMap)
  return configMap
}

export const initData = {
  staticData: staticDataConfig.initData.formInitData,
  ...getConfig(TmpPackage)
}

console.log('initConfig', initData)
